import $ from 'jquery';
import globalScope from 'core/globalScope';
import initHeaderFooter from 'core/initHeaderFooter';
import 'core/fileExtensions';
import 'core/mimeTypes';
import ga from 'ga';
import { moteur_top } from 'modules/moteur_top';
import newsletter_footer from 'modules/newsletter_footer';
import appnexusInit from 'pubs/appnexus_init';
import 'core/screenSize';
import 'remodal';
import 'modules/jquery.slideshow';
import 'modules/jquery.depotcv1click';
import 'modules/mentions_legales';
import { trackerCreationAlerte } from 'modules/abtasty';
import trackerOffresRecommandees from 'modules/tracking_offres_reco';
import 'jquery.cookie';
import 'sass/cadremploi-webapp/home.scss';

function home(configuration) {
  moteur_top(configuration);
  newsletter_footer();
  trackerOffresRecommandees();
  const pubs = {
    normales: [
      {
        invCode: 'cadremploi_accueil_pave_atf',
        sizes: {
          smartphone: [300, 250],
          tablette: [300, 250],
          desktop: [300, 250]
        },
        targetId: 'ResponsivePubPaveSimple'
      }
    ]
  };
  appnexusInit(pubs, function() {
    $('.bloc-entreprise-qui-recrute')
      .last()
      .hide();
  });

  const recherchesMemorisees = $('.js-lancer-recherche-memorisee'),
    offresRecommandees = $('.js-offre-recommandee'),
    offresRecommandeesLoggue = $('.js-offre-recommandee-loggue'),
    recherchesMemoriseesAvecAlerte = $('.js-recherche-memorisee-modifier-alerte');

  recherchesMemorisees.click(function() {
    ga.deprecatedSendEvent(
      'navigation',
      'clic_hp_derniere_recherche',
      'clic_hp_derniere_recherche'
    );
  });
  $('.js-recherche-memorisee').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'activer_alerte_derniere_recherche');
  });
  if (recherchesMemoriseesAvecAlerte.length > 0) {
    ga.sendNonInteractiveEvent(
      'temporaire',
      'analyse_hp',
      'affichage_alerte_activee_derniere_recherche'
    );
    recherchesMemoriseesAvecAlerte.click(function() {
      ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'modifier_alerte_derniere_recherche');
    });
  }
  if (recherchesMemorisees.length > 0) {
    ga.sendNonInteractiveEvent(
      'navigation',
      'affichage_hp_derniere_recherche',
      'affichage_hp_derniere_recherche'
    );
    if (offresRecommandees.length > 0) {
      ga.sendNonInteractiveEvent(
        'navigation',
        'affichage_hp_offre_reco',
        offresRecommandees.length
      );
      offresRecommandees.click(function() {
        const offreId = $(this).attr('data-offreId');
        ga.deprecatedSendEvent('navigation', 'clic_hp_offre_reco', offreId);
      });
    }
  }
  if (offresRecommandeesLoggue.length > 0) {
    ga.sendNonInteractiveEvent(
      'navigation',
      'affichage_hp_offre_reco',
      offresRecommandeesLoggue.length
    );
    offresRecommandeesLoggue.click(function() {
      const offreId = $(this).attr('data-offreId');
      ga.deprecatedSendEvent('navigation', 'clic_hp_offre_reco', offreId);
    });
  }
  $('.js-trouver-un-emploi').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_trouver_un_emploi');
  });
  $('.js-ils-recrutent-entreprise').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_ils_recrutent_entreprises');
  });
  $('.js-ils-recrutent-logo').click(function() {
    ga.deprecatedSendEvent(
      'navigation',
      'clic_hp_ils_recrutent_logo',
      'clic_hp_ils_recrutent_logo'
    );
  });
  $('#js-lien-region-rhonealpes').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_region_rhonealpes');
  });
  $('#js-lien-region-grandest').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_region_grandest');
  });
  $('#js-lien-region-grandouest').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_region_grandouest');
  });
  $('#js-lien-region-nord').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_region_nord');
  });
  $('#js-lien-region-iledefrance').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_region_iledefrance');
  });
  $('#js-lien-region-mediterranee').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_region_mediterranee');
  });
  $('#js-lien-region-sudouest').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_region_sudouest');
  });
  $('#js-lien-region-toutes').click(function() {
    ga.deprecatedSendEvent('temporaire', 'analyse_hp', 'clic_region_toutes');
  });
  $('.js-creer-alerte').click(function() {
    trackerCreationAlerte();
  });
  $('.js-footer-newsletter').click(function() {
    ga.deprecatedSendEvent(
      'navigation',
      'clic_hp_inscription_newsletter',
      'clic_hp_inscription_newsletter'
    );
  });
  $('.js-article-edito').click(function() {
    ga.deprecatedSendEvent('navigation', 'clic_hp_article_edito', 'clic_hp_article_edito');
  });

  initHeaderFooter(configuration);

  // Gestion de la popup de d�p�t de cv
  if (!$.cookie('hasClosedHomeDepotCV')) {
    $('.js-depot-cv-container').slideDown();
  }

  const $modalDepotCvCloseButton = $('.popover-close.js-close-depot-cv');
  $modalDepotCvCloseButton.click(() => {
    $.cookie('hasClosedHomeDepotCV', true, { expires: 7 });
    $('.js-depot-cv-container').slideUp();
  });

  $('.js-depotcv1click').depotcv1click({
    onUploadStarted: function() {
      $('.js-depotcv1click .cv-container, .bkg-pattern').hide();
    },
    onUploadFailed: function() {
      $('.js-depotcv1click .cv-container').show();
    },
    loadingTemplate: '<div class="loader"><div class="loading-animation"></div></div>',
    source: 'home' // custom option for tracking
  });

  // Read more des listes SEO
  $('.js-read-more').click(function() {
    $('.js-more-content').slideToggle();
  });

  $('#ResponsivePubPaveSimple iframe').each(function() {
    const iframe = this;
    $(iframe).on('load', function() {
      // Une image de 1x1 pixel indique "pas de pub"
      const firstImg = $(this)
        .contents()
        .find('img')[0];

      const hasAdblock =
        $(this)
          .contents()
          .find('script')
          .last()
          .next().length === 0;

      const imageDePlusDUnPixel = firstImg && firstImg.naturalHeight !== 1;
      if (!hasAdblock && (!firstImg || imageDePlusDUnPixel)) {
        // si pub affichee, on masque le dernier bloc "entreprise qui recrute" (2 blocs + bloc pub)
        $('.bloc-entreprise-qui-recrute')
          .last()
          .hide();
      }
    });
  });

  // Modal video entreprise
  $('.js-open-video-modal').click(function() {
    const modalIdToOpen = '#' + $(this).attr('data-open-id');
    $(modalIdToOpen)
      .remodal()
      .open();
    const src =
      $(modalIdToOpen)
        .find('iframe')
        .attr('src') + '&autoplay=true';
    $(modalIdToOpen)
      .find('iframe')
      .attr('src', src);
  });

  $(globalScope.document).on('closed', '.remodal', function() {
    const src = $(this)
      .find('iframe')
      .attr('src');
    if (src) {
      const indexAutoplay = src.indexOf('&autoplay=true');
      if (indexAutoplay !== -1) {
        $(this)
          .find('iframe')
          .attr('src', src.substring(0, indexAutoplay));
      }
    }
  });

  if (configuration.doitAfficherModaleReactivationCompte) {
    $('#js-modal-reactivation-compte')
      .remodal()
      .open();
  }

  // Initialisation du slideshow des conseils
  $('#js-slideshow-conseil').slideshow({ timer: 4500 });

  // Initialisation du slideshow des services
  $('#js-slideshow-services').slideshow({ timer: 4500 });

  // rattrapage des images lazyload�es dans un carousel
  $('.lazy-carousel').each(function(index, element) {
    element.setAttribute('src', element.dataset.src);
  });
}

export default home;
